import type { MembershipNotificationsSchemaWS } from '@libs/data-access/queries'
import { wsServices } from '@libs/data-access/queries'

export const useNotificationsSubscription = wsServices.core.subscription.create(
  {
    subscribePayload: () => ({
      channel: 'NotificationChannel'
    }),
    messages: {
      onNotificationUpdate:
        wsServices.core.subscription.defineMessageHandler<MembershipNotificationsSchemaWS>(
          {
            type: 'api/FETCH_UNREAD_NOTIFICATIONS_SUCCEEDED'
          }
        )
    }
  }
)
